import { SocialProfilesService } from './SocialProfilesService';

export default new SocialProfilesService('youtube/profiles');
